import {
  createLoan,
  CreateLoanReturn,
  createLoanInterest,
  CreateLoanInteresReturn,
  deleteLoan,
  DeleteLoanReturn,
  deleteLoanInterest,
  updateLoan,
  UpdateLoanReturn,
} from 'graphql/loans/mutations';

import { createMutationHook } from 'hooks/factories/createMutationHook';

export const useCreateLoan = createMutationHook<CreateLoanReturn>(createLoan);
export const useUpdateLoan = createMutationHook<UpdateLoanReturn>(updateLoan);
export const useDeleteLoan = createMutationHook<DeleteLoanReturn>(deleteLoan);
export const useCreateLoanInterest = createMutationHook<CreateLoanInteresReturn>(createLoanInterest);
export const useDeleteLoanInterest = createMutationHook<null>(deleteLoanInterest);
